<template>
    <div style="padding-bottom: 0 !important;" class="table-responsive has-options">
        <b-table hover :items="indumentaria.tallasSelect" :fields="fields" id="tallas-table">
            <template #cell(stock)="{ item }">
                <div class="d-flex justify-content-center align-items-center">
                    <div class="col-12">
                        <FormInput label="" type="number" name="stock" :id="'stock-' + item.id" rules="required" v-model="item.stock_total" />
                    </div>
                </div>
            </template>
            <template #cell(stock_seleccionable)="{ item }">
                <div class="d-flex justify-content-center align-items-center">
                    <div class="col-12">
                        <FormInput label="" type="number" name="stock-seleccionable" :id="'stock-seleccionable-' + item.id" rules="" v-model="item.stock_seleccionable"/>
                    </div>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        props: ['indumentaria'],
        data() {
            return {
                fields: [
                    { key: "nombre", label: "Talla", class: 'text-center' },
                    { key: 'stock', label: "Stock", class: 'text-center' },
                    { key: 'stock_seleccionable', label: "Stock máximo seleccionable", class: 'text-center' }
                ],
            }
        }
    }
</script>